<template>
  <el-dialog :visible="dailogShow" title="课题详情" :before-close="handleCloseDailog">

    <el-descriptions :column="1" border>
      <el-descriptions-item label="模块">{{ ketiInfo.moduleName }}</el-descriptions-item>
      <el-descriptions-item label="名称">{{ ketiInfo.projectName }}</el-descriptions-item>
      <el-descriptions-item label="负责人">{{ fuzerenInfo.userName }}</el-descriptions-item>
      <el-descriptions-item label="单位">{{ fuzerenInfo.danWeiMingCheng }}</el-descriptions-item>
      <el-descriptions-item label="部门">{{ fuzerenInfo.buMen }}</el-descriptions-item>
      <el-descriptions-item label="科室">{{ fuzerenInfo.keShi }}</el-descriptions-item>
    </el-descriptions>

    <div class="dialog-footer">
      <el-button v-if="!hasRenLing" type="primary" @click="handleDoRenLing">认 领</el-button>
      <el-button v-else type="primary" disabled>已认领</el-button>
      <el-button @click="handleCloseDailog">取 消</el-button>

    </div>

  </el-dialog>
</template>
<script>
import pathReq from '@/api/pathlist'
export default {
  data() {
    return {
      dailogShow: false,
      hasRenLing: false,
      ketiInfo: {},
      fuzerenInfo: {},
      doRenLingKey: null
    }
  },
  methods: {
    show(moduleCode, moduleKey) {
      const that = this
      const path = '/api/services/app/WorkEventMemberNewService/GetRenLingInfo'
      pathReq.getList(path, { moduleCode: moduleCode, moduleKey: moduleKey }).then(r => {
        that.hasRenLing = r.data.result.hasRenLing
        that.ketiInfo = r.data.result.ketiInfo
        that.fuzerenInfo = r.data.result.fuzerenInfo
        that.doRenLingKey = r.data.result.doRenLingKey
      })

      this.dailogShow = true
    },
    /** 关闭 */
    handleCloseDailog() {
      this.dailogShow = false
    },
    /** 认领 */
    handleDoRenLing() {
      const that = this
      const path = '/api/services/app/WorkEventMemberNewService/DoRenLing'
      var data = {
        moduleCode: this.moduleCode,
        renlingKeys: []
      }
      data.renlingKeys.push(this.doRenLingKey)
      pathReq.postForm(path, data).then(_ => {
        that.$message.success('认领成功！')
        that.dailogShow = false
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
